export const SWIPE_THRESHOLD:number = 60;
